import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const ThankYouPage = () => {
     useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <Helmet>
        {/* <title>Thank You - Selfsync</title> */}
        {/* <meta
          name="description"
          content="Thank you for joining the Selfsync waitlist. Get ready for exclusive updates and early access to our launch!"
        /> */}
        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1183772839914578');
            fbq('track', 'PageView');
            fbq('track', 'Lead');
          `}
        </script>

        <noscript>
          {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=1183772839914578&ev=PageView&noscript=1"
            />`}
        </noscript>
      </Helmet>

      <div className="bg-white max-w-2xl w-full text-center shadow-xl rounded-lg p-6 md:p-8">
        {/* Heading */}
        <h1
          className="text-4xl md:text-7xl font-semibold bg-gradient-to-r from-purple-500 to-cyan-400 text-transparent bg-clip-text mb-8"
          style={{ fontFamily: "cursive" }}
        >
          Thank you!
        </h1>

        {/* Subtext */}
        <h2 className="text-xl font-semibold text-gray-800 mb-2 mt-5">
          For Joining Our Waitlist
        </h2>

        <p className="text-gray-600 mb-4 text-base">
          Your registration has been received! We're thrilled to have you join
          the Selfsync journey. As a part of our early access list, you'll be
          the first to know when we go live.
        </p>
        <p className="text-gray-500 text-base mb-2">
          Stay tuned for exclusive updates and early features. We appreciate
          your interest and support.
        </p>

        <p className="text-purple-500 font-medium italic mt-4 text-right">
          — Team Selfsync
        </p>
      </div>
    </main>
  );
};

export default ThankYouPage;
